import styled from '@emotion/styled';
import { FunctionComponent } from 'react';
import { Trans } from 'react-i18next';

import { PaletteColor, Size } from '../../styling/AppStyles';
import { ExinH3Text, ExinSmallText } from '../styled/ExinText';
import EnvelopeIcon from './EnvelopeIcon';
import MarkerIcon from './MarkerIcon';
import { Trainer } from './TrainerList';
import WebsiteIcon from './WebsiteIcon';

const TrainerListItemContainer = styled.div`
  padding: ${Size.medium};
  box-sizing: border-box;

  border: 2px solid ${PaletteColor.gray};
  border-radius: 20px;

  position: relative;
`;

const TrainerListItemDistance = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  top: ${Size.small};
  right: ${Size.small};
  font-size: 0.875em;
  line-height: 1em;

  > div {
    margin: 2px;

    > svg {
      display: block;
      margin: auto;
      height: ${Size.small};
    }
  }
`;

const ImageContainer = styled.div`
  height: 30px;
  > img {
    max-height: 30px;
  }
`;

const ContactContainer = styled.div`
  &,
  & > a {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  & > a {
    margin: 0 0 0 ${Size.small};
    &:first-of-type {
      margin-left: 0;
    }
    & > svg {
      margin-right: calc(${Size.smaller} / 2);
    }
  }
`;

const TrainerListItem: FunctionComponent<{
  trainer: Trainer;
}> = ({ trainer }) => {
  return (
    <TrainerListItemContainer>
      {trainer.img && (
        <ImageContainer>
          <img src={trainer.img} alt={trainer.name} />
        </ImageContainer>
      )}

      {trainer.distance && (
        <TrainerListItemDistance>
          <div>{Math.round(trainer.distance)} km</div>
          <div>
            <MarkerIcon />
          </div>
        </TrainerListItemDistance>
      )}

      <ExinH3Text
        style={trainer.img ? {} : { marginTop: 0 }}
        // @NOTE potentially executes malicious javascript;
        dangerouslySetInnerHTML={{ __html: trainer.name }}
      />

      <ExinSmallText
        // @NOTE potentially executes malicious javascript;
        dangerouslySetInnerHTML={{ __html: trainer.address }}
      />

      {trainer.mail || trainer.url ? (
        <ContactContainer>
          {trainer.mail && (
            <a href={`mailto:${trainer.mail}`}>
              <EnvelopeIcon />
              <ExinSmallText as="span">
                <Trans i18nKey="showDetailsLabelEmail">Contact</Trans>
              </ExinSmallText>
            </a>
          )}
          {trainer.url && (
            <a href={trainer.url}>
              <WebsiteIcon />
              <ExinSmallText as="span">
                <Trans i18nKey="showDetailsLabelWebsite">Website</Trans>
              </ExinSmallText>
            </a>
          )}
        </ContactContainer>
      ) : null}
    </TrainerListItemContainer>
  );
};
export default TrainerListItem;
